import store from "../store/index";
//------------
// get action
//------------
export default function getAction(name) {
  const this_store = store;
  const actions = this_store.getters["combat/getActions"]
  let action = actions.find((a) => a.name == name);
  return action;
}
